import { useRef } from 'react';

import { useLegalClientRepresentativeSaveTaxResidences } from 'api/requests';
import { isGlobalProject } from 'config';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { OnboardingTaxResidencyFormType } from 'modules/onboarding/common/forms/onboardingTaxResidencyForm';
import {
  getInitialData,
  getSubmitData,
  getSubmitDataWithFiles,
} from 'modules/onboarding/common/helpers/taxResidency';
import {
  useBeforeSubmitTaxResidency,
  useOnboardingCountries,
} from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useTaxResidency = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();
  const { error, loading, saveTaxResidences } =
    useLegalClientRepresentativeSaveTaxResidences();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialData = useRef(
    getInitialData(data.currentClient.taxResidences)
  ).current;
  const initialValues = useRef(initialData.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData.files);

  const onSubmit = useBeforeSubmitTaxResidency(
    async (values: OnboardingTaxResidencyFormType) => {
      const submitData = isGlobalProject()
        ? getSubmitDataWithFiles(values)
        : getSubmitData(values);
      const res = await saveTaxResidences(data.currentClient.id, submitData);

      if (res) {
        goToNext();
      }
    }
  );

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
    files,
    submitDisabled,
    submitLoading: loading,
    initialValues,
    countries,
    countriesLoading,
  };
};
